import React, { useState } from "react";
import { Col, Container, Row, Spinner, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../src/assets/svg/logo.svg";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie";
import { APICall } from "../Utls/Api";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};
    if (!email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(email))
      newErrors.email = "Invalid email format";

    if (!password) newErrors.password = "Password is required";
    else if (password.length < 6)
      newErrors.password = "Password must be at least 6 characters";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const data = {
        email,
        password,
      };

      const response = await APICall("/auth/admin/login", "POST", data);

      if(response.status){
        // Store token in cookies
        Cookies.set("token", response.token, { expires: 1 }); // expires in 1 day
        window.location.reload()

      }
    } catch (error) {
      toast.error(error.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 bg-light">
      <ToastContainer />
      <Container fluid className="h-100">
        <Row className="min-vh-100">
          <Col
            md={6}
            className="d-flex  align-items-center justify-content-center bg-white"
          >
            <div style={{ width: "100%", maxWidth: 500 }} className="p-4">
              <div className="mb-4">
                <h4 className="fw-bold mt-3">Welcome Back</h4>
                <p className="text-muted">Login to your account</p>
              </div>

              <Form className="mt-5">
                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Email</Form.Label>
                  <Form.Control
                    className="rounded-0 py-2"
                    type="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="fw-semibold">Password</Form.Label>
                  <div className="position-relative">
                    <Form.Control
                      className="rounded-0 py-2"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      isInvalid={!!errors.password}
                    />
                    <span
                      style={{ color: "#6C6DC6", fontSize: "12px" }}
                      role="button"
                      className="position-absolute top-50 end-0 translate-middle-y me-3 "
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>

                <div className="d-grid mt-4">
                  <button
                    type="button"
                    className="btn text-white py-2 rounded-0"
                    style={{ backgroundColor: "#6C6DC6" }}
                    onClick={handleLogin}
                    disabled={loading}
                  >
                    {loading ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </Col>

          <Col
            md={6}
            className="d-none d-md-flex flex-column justify-content-center align-items-center text-white"
            style={{ backgroundColor: "#6C6DC6" }}
          >
            <img src={logo} height={60} alt="logo" className="mb-4" />
            <h3 className="fw-bold">Welcome to Our Platform</h3>
            <p className="text-center px-5">
              Experience a seamless and secure way to manage your account. We're
              here to support you every step of the way.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
